import React from "react";
import { IFormConfirmationProps } from "../Form.types";
import SuccessfulSubmitIcon from "../../../theme/assets/successful-submit-icon.svg";
import { Col, Container, Row, Image } from "react-bootstrap";
import BUTTON from "../../button/Button.component";
import FormStyles from "../Form.styles";
import { useDispatch, useSelector } from "react-redux";
import { FormService } from "../Form.service";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { RootState } from "../../../state-management/root-reducer";

const renderMessage = (pinMode: {
  enabled: boolean;
  pin: import("../../map/Map.types").ISelectedMarker;
  selectedBracketType: string | null;
}): JSX.Element => {
  return pinMode.enabled ? (
    <p>
      Your streetlight issue has been submitted; however, we must confirm this
      is a Consumers Energy light. Thank you for your patience while we complete
      this investigation. We will be in touch as soon as a decision is made.
    </p>
  ) : (
    <p>
      Your streetlight outage report has been submitted. Check your email for
      the details of your submission.{" "}
    </p>
  );
};

const FORM_CONFIRMATION: React.FC<IFormConfirmationProps> = (
  props: IFormConfirmationProps
) => {
  const { submittedOutage, onClose, imageUploadState } = props;
  const dispatch = useDispatch();
  const sendDataToGTM = useGTMDispatch();
  const formService: FormService = FormService.getInstance(
    dispatch,
    sendDataToGTM
  );

  // App state
  const { pinMode } = useSelector((state: RootState) => state.globalState.ui);

  return (
    <FormStyles.FormConfirmationContainer
      id="confirmationContainer"
      data-testid="confirmation-container"
      className="form-confirmation-container"
    >
      <FormStyles.ConfirmationIcon
        className="confirmation-icon"
        src={SuccessfulSubmitIcon}
      />
      <FormStyles.ConfirmationHeading className="confirmation-heading">
        <h1>Thank you!</h1>
        {renderMessage(pinMode)}
      </FormStyles.ConfirmationHeading>

      <FormStyles.ConfirmationReport className="confirmation-report">
        <h2>Report Summary</h2>
        <Container className="confirmation-report-container">
          <Row>
            <Col xs={3} className="label-column">
              Date:
            </Col>
            <Col xs="auto">{formService.getReportedDate(submittedOutage)}</Col>
          </Row>
          <Row>
            <Col xs={3} className="label-column">
              Time:
            </Col>
            <Col xs="auto">{formService.getReportedTime(submittedOutage)}</Col>
          </Row>
          <Row>
            <Col xs={3} className="label-column">
              Issue:
            </Col>
            <Col className="wrapped-column">
              <b>{submittedOutage?.outageReason}</b>
            </Col>
          </Row>
          <Row>
            <Col xs={3} className="label-column">
              Comments:
            </Col>
            <Col className="wrapped-column">{submittedOutage?.comments}</Col>
          </Row>
        </Container>
      </FormStyles.ConfirmationReport>

      {imageUploadState && imageUploadState.imgDataUrl && (
        <Image
          src={imageUploadState.imgDataUrl as string}
          className="submission-image"
        />
      )}
      <BUTTON
        className="back-button"
        variant="primary"
        onClick={(event) => {
          sendDataToGTM({
            event: "eventTracking",
            category: "Outage",
            action: "Street Light",
            label: "Back to map clicked from confirmation screen",
          });
          onClose(event);
        }}
      >
        Back to Outage Map
      </BUTTON>
    </FormStyles.FormConfirmationContainer>
  );
};

export default FORM_CONFIRMATION;
